import { INode } from 'shared/types/tree'
import { JsonObject, JsonValueType } from 'shared/types'
import { NodeType } from 'shared/types/ingestion'

export const contentKeys = [
  'description',
  'title',
  'body.value',
  'body.answer_placeholder',
  'body.placeholder_value',
  'body.summary.long',
  'body.summary.short',
]

export const withoutContent = [
  NodeType.Course,
  NodeType.Inline,
  NodeType.SkillsList,
  NodeType.AttachmentsList,
  NodeType.NodeList,
]

export function isValidJsonObj(obj: unknown): obj is JsonObject {
  return !!obj && typeof obj === 'object' && !Array.isArray(obj)
}

const regexTest = (reg: RegExp, content: unknown): content is string => {
  if (typeof content !== 'string') return false
  reg.lastIndex = 0
  const result = reg.test(content)
  reg.lastIndex = 0
  return result
}

export function includesTest(
  testWith: RegExp | string,
  testOn: unknown,
): testOn is string {
  if (typeof testOn !== 'string') return false
  if (testWith instanceof RegExp) {
    return regexTest(testWith, testOn)
  }
  return testOn.includes(testWith)
}

export function replaceParamsForUpdate({
  searchString,
  existingParams,
  contentTransform,
}: {
  existingParams: Partial<INode>
  searchString: RegExp | string
  contentTransform: (content: string) => string
}) {
  const doTransform = (data: JsonValueType) => {
    if (includesTest(searchString, data)) {
      return contentTransform(data)
    }
    return data
  }

  const clone = JSON.parse(JSON.stringify(existingParams))
  contentKeys.forEach((keySet) =>
    doTransformForKeys(keySet.split('.'), clone, doTransform),
  )
  return clone
}

function doTransformForKeys(
  [currentKey, ...rest]: string[],
  obj: unknown,
  transform: (content: JsonValueType) => JsonValueType,
) {
  if (!isValidJsonObj(obj)) return obj
  const currentValue = obj[currentKey]

  if (!rest.length) {
    if (!isValidJsonObj(currentValue)) {
      const newValue = transform(currentValue)
      if (newValue) {
        obj[currentKey] = newValue
      }
    }
  } else {
    doTransformForKeys(rest, currentValue, transform)
  }
}
